module.exports = __webpack_public_path__ + "media/images/logo_briefly24_beta-ce483b8ef5da1226b08c62bf0d751268.png";